;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "Pay",
  props: ["callback_url", "request_type"],
  data: function data() {
    return {
      currency: null,
      logo: null,
      invoice_amount: null,
      agent_fee: 0,
      fee: 0,
      invoice_number: null,
      url: null,
      total_amount: 0,
      shortcode: null,
      gateway: null,
      stkOpen: false,
      stk_phone: null,
      initiating: false,
      base_url: "",
      payment_instructions: "",
      div_id: null,
      content_div: null,
      success_message: null,
      error_message: null
    };
  },

  created: function created() {
    var id = this.$attrs["gid"];
    this.payment_instructions = this.$attrs["instructions"];
    this.div_id = "mpesaModal" + id;
    this.content_div = "contentDiv" + id;
  },
  mounted: function mounted() {
    var _this = this;

    this.invoice_number = this.$attrs["invoice_no"];
    this.invoice_amount = this.$attrs["amount_net"];
    this.currency = this.$attrs["currency"];
    this.fee = this.$attrs["fee"];
    this.shortcode = this.$attrs["shortcode"];
    this.gateway = this.$attrs["gateway"];
    this.agent_fee = this.$attrs["agent_fee"];
    this.url = this.$attrs["status_api_url"];
    this.logo = this.$attrs["logo"];
    this.base_url = this.$attrs["base_url"];
    this.stk_phone = this.$attrs["msisdn"];

    this.write_instructions(this.content_div, this.payment_instructions);
    this.set_total_amount();
    $("#" + this.div_id).on("hidden.bs.modal", function () {
      _this.error_message = null;
      _this.success_message = null;
      _this.initiating = false;
      _this.destroyTimer();
    });
  },
  computed: {
    valid_phone: function valid_phone() {
      if (this.stk_phone) {
        var trimmed_stk_phone = this.stk_phone.trim();
        var isValidCharacters = /^[\d+]*$/.test(trimmed_stk_phone);
        var isValidPattern = trimmed_stk_phone.match(/^\+?(254\d{9}|0\d{9})$/g);
        return isValidCharacters && isValidPattern ? true : false;
      }
      return false;
    }
  },
  methods: {
    write_instructions: function write_instructions(div, instructions) {
      $("#" + div).html(instructions);
    },

    formatNumber: function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    toggleStkOpen: function toggleStkOpen() {
      if (this.stkOpen) {
        this.stkOpen = false;
      } else {
        this.stkOpen = true;
      }
    },
    destroyTimer: function destroyTimer() {
      this.$refs.timer.destroyTimer();
    },

    set_total_amount: function set_total_amount() {
      this.total_amount = Math.ceil(parseFloat(this.invoice_amount) + parseFloat(this.fee) + parseFloat(this.agent_fee));
    },
    stk_menu: function stk_menu() {
      var _this2 = this;

      this.initiating = true;
      this.error_message = null;
      this.success_message = null;
      var urlIs = this.base_url + "/api/payment/mpesa/stk/" + this.request_type;
      var api_headers = {
        Authorization: ""
      };
      var params = {
        req_ref: this.invoice_number,
        gateway: this.gateway,
        preferred_msisdn: this.stk_phone
      };
      Vue.axios.post(urlIs, params, {
        headers: api_headers
      }).then(function (response) {
        if (response.data.status == 422) {
          _this2.initiating = false;
          _this2.error_message = "Unable to push STK Menu at this time. Try again later !";
        } else {
          _this2.initiating = false;
          _this2.success_message = "Please, check your phone for STK Menu";
        }
      }).catch(function () {
        _this2.initiating = false;
        _this2.error_message = "Unable to push STK Menu at this time. Try again later !";
      }).then(function () {
        _this2.initiating = false;
        _this2.toggleStkOpen();
      });
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":_vm.div_id,"tabindex":"-1","role":"dialog","aria-labelledby":"mpesaModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-full",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body d-flex align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mx-auto"},[_c('img',{staticClass:"navbar-brand-img",attrs:{"src":_vm.logo,"alt":"..."}}),_vm._v(" "),_c('div',{staticClass:"card mt-3"},[_c('invoice-summary',{attrs:{"invoice":_vm.invoice,"gateway_name":"mpesa","currency":_vm.currency,"online_convenience_fee":_vm.fee,"total_amount":_vm.total_amount,"amount_net":_vm.invoice_amount}}),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.error_message)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                    "+_vm._s(_vm.error_message)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.success_message)?_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n                    "+_vm._s(_vm.success_message)+"\n                  ")]):_vm._e(),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n                      Click\n                      "),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.toggleStkOpen}},[_vm._v("here")]),_vm._v("\n                      to receive M-PESA Menu\n                      "),(_vm.stkOpen)?_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('label',[_vm._v("Phone Number\n                            "),(!_vm.valid_phone)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("* required")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.stk_phone),expression:"stk_phone"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Enter a valid safaricom number"},domProps:{"value":(_vm.stk_phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.stk_phone=$event.target.value}}})]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.valid_phone)?_c('div',{staticClass:"row"},[(_vm.initiating)?_c('button',{staticClass:"btn btn-sm btn-primary"},[_c('span',{staticClass:"spinner-grow spinner-grow-sm"}),_vm._v("\n                            Processing ...\n                          ")]):_vm._e(),_vm._v(" "),(!_vm.initiating)?_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button"},on:{"click":_vm.stk_menu}},[_vm._v("\n                            Initiate Payment\n                          ")]):_vm._e()]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('li',[_vm._v("Enter your M-PESA PIN and click OK")]),_vm._v(" "),_c('li',[_vm._v("You will receive a confirmation SMS from M-PESA")])]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("\n                    After you receive a successful reply from M-PESA, click\n                    the complete button below.\n                  ")])]),_vm._v(" "),(_vm.payment_instructions)?_c('div',{staticClass:"card-body"},[_c('p',[_vm._v("Or follow instructions below")]),_vm._v(" "),_c('div',{attrs:{"id":_vm.content_div}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-footer d-flex justify-content-end align-items-center"},[_c('a',{staticClass:"btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"},on:{"click":_vm.destroyTimer}},[_vm._v("Cancel")]),_vm._v(" "),_c('complete-button',{ref:"timer",attrs:{"gateway":"mpesa","status_api_url":_vm.url,"invoice_no":_vm.invoice_number,"callback_url":_vm.callback_url}})],1)],1)])])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header d-flex align-items-center"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"fe fe-x text-dark",attrs:{"aria-hidden":"true"}})])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e55d70c4", __vue__options__)
  } else {
    hotAPI.reload("data-v-e55d70c4", __vue__options__)
  }
})()}